import { coreHTTPClient } from "./webclient";

export type MapsGeocodeParams = {
  address?: string;
  lat?: number;
  lng?: number;
  language?: string;
  region?: string;
  country?: string;
  limit?: number;
};

export type MapsGeocodeResult = {
  place_id: string;
  formatted_address: string;
  lat: string;
  lon: string;
  display_name: string;
  address: Record<string, string>;
  types: string[];
  location_type?: string;
  viewport?: {
    northeast: { lat: number; lng: number };
    southwest: { lat: number; lng: number };
  };
  boundingbox?: [string, string, string, string];
};

export type MapsGeocodeResponse = {
  status: "OK" | "ZERO_RESULTS";
  results: MapsGeocodeResult[];
};

export type MapsStaticParams = {
  lat: number;
  lng: number;
  zoom?: number;
  width?: number;
  height?: number;
  maptype?: "satellite" | "roadmap" | "hybrid" | "terrain";
  path?: string | string[];
  markers?: string | string[];
};

const MAPS_BASE = "v4/maps";

/** GET /v4/maps/geocode/ */
export async function getMapsGeocode(
  params: MapsGeocodeParams
): Promise<MapsGeocodeResponse> {
  const response = await coreHTTPClient.get<MapsGeocodeResponse>(
    `${MAPS_BASE}/geocode/`,
    { params }
  );
  return response.data;
}

/** GET /v4/maps/static/ — authenticated PNG blob (key stays on backend). */
export async function getMapsStatic(params: MapsStaticParams): Promise<Blob> {
  const response = await coreHTTPClient.get<Blob>(`${MAPS_BASE}/static/`, {
    params,
    responseType: "blob",
    paramsSerializer: (p) => {
      const search = new URLSearchParams();
      Object.entries(p).forEach(([key, value]) => {
        if (value === undefined || value === null) return;
        if (Array.isArray(value)) {
          value.forEach((item) => {
            if (item !== undefined && item !== null && item !== "") {
              search.append(key, String(item));
            }
          });
          return;
        }
        search.append(key, String(value));
      });
      return search.toString();
    },
  });
  return response.data;
}
